import { IsNumber, IsString } from "class-validator";

export class SearchAccountsPayload {
    @IsString()
    accountName: string;

    @IsNumber()
    limit: number;
}